// Babel 的 poly-fill 简单的用一个就行了
if ( typeof Object.assign !== 'function' ) {
    console.info("add Object.assign poly fill");
    Object.assign = function( new_object , src_object ){
        new_object = JSON.parse( JSON.stringify(src_object));
        return new_object;
    }
}
export default null;